import { Injectable } from '@angular/core';
import { Plugins } from '@capacitor/core';
import { BranchInitEvent } from 'capacitor-branch-deep-links';
import { Router } from '@angular/router';
declare let branch: any;

const { BranchDeepLinks } = Plugins;

@Injectable({
    providedIn: 'root'
})
export class BranchService {
    constructor(private router: Router) {}

    initializeMobile() {
        BranchDeepLinks.addListener('init', (event: BranchInitEvent) => {
            if (event.referringParams['+clicked_branch_link'] && event.referringParams['$deeplink_path']) {
                this.router.navigateByUrl(event.referringParams['$deeplink_path']);
            }
        });

        BranchDeepLinks.addListener('initError', (error: any) => {
            console.error(error);
        });
    }

    initializeWeb() {
        branch.init('key_live_dnJ9Doy0AEiNd12eqEjDaaepzAmkvnpG', (err, data) => {
            if (err) {
                console.error(err);
            }
            const deeplinkUrl = data.data_parsed['$deeplink_path'];
            if (deeplinkUrl) {
                this.router.navigateByUrl(deeplinkUrl);
            }
        });
    }
}
